import PropTypes from "prop-types";
import React from "react";

export default class FileTemplate extends React.Component {
    render() {
        const { data, onDownloadClick } = this.props;
        const { id, filename, recordCount } = data;
        if (filename == null) return null;
        return <a href="#" className="download"
                  onClick={onDownloadClick.bind(this, data)}
                  data-id={id}
                  data-filename={filename}
                  data-count={recordCount}><span className="glyphicon glyphicon-download-alt"></span> {filename} </a>;
    }
}

FileTemplate.propTypes = {
    data: PropTypes.object.isRequired,
    onDownloadClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/lib/hex/lib/resultsview/templates/FileTemplate.js